module.exports = __webpack_public_path__ + "media/images/lp/support3-pc-90979b03cc59bee4017598d369673972.png";